// Analytics service for Google Analytics 4
/* global dataLayer, gtag */ // eslint-disable-line no-unused-vars
class AnalyticsService {
  constructor() {
    this.measurementId = localStorage.getItem('bullbearly-ga4-measurement-id') || 'G-ZZZ1G8L0FD';
    this.isInitialized = false;
    this.gtag = null;
  }

  // Initialize Google Analytics
  initialize(measurementId = null) {
    if (measurementId) {
      this.measurementId = measurementId;
      localStorage.setItem('bullbearly-ga4-measurement-id', measurementId);
    }

    // Load Google Analytics script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;
    this.gtag = gtag;

    gtag('js', new Date());
    gtag('config', this.measurementId, {
      page_title: document.title,
      page_location: window.location.href
    });

    this.isInitialized = true;
    console.log('Analytics initialized with measurement ID:', this.measurementId);
  }

  // Track page views
  trackPageView(pageName, pagePath) {
    if (!this.isInitialized || !this.gtag) return;

    this.gtag('event', 'page_view', {
      page_title: pageName,
      page_location: window.location.href,
      page_path: pagePath
    });
  }

  // Track custom events
  trackEvent(eventName, parameters = {}) {
    if (!this.isInitialized || !this.gtag) return;

    this.gtag('event', eventName, parameters);
  }

  // Track waitlist signup
  trackWaitlistSignup(email) {
    this.trackEvent('waitlist_signup', {
      event_category: 'engagement',
      event_label: 'email_signup',
      custom_parameter_1: email.substring(0, 5) + '***' // Partial email for privacy
    });
  }

  // Track user login
  trackUserLogin(userRole) {
    this.trackEvent('login', {
      event_category: 'engagement',
      event_label: 'user_login',
      custom_parameter_1: userRole
    });
  }

  // Track feature usage
  trackFeatureUsage(featureName, action) {
    this.trackEvent('feature_usage', {
      event_category: 'feature_interaction',
      event_label: featureName,
      custom_parameter_1: action
    });
  }

  // Track RSS feed addition
  trackRSSFeedAdded(feedName) {
    this.trackEvent('rss_feed_added', {
      event_category: 'content_management',
      event_label: feedName
    });
  }

  // Track AI prompt usage
  trackAIPromptUsed(promptName) {
    this.trackEvent('ai_prompt_used', {
      event_category: 'ai_interaction',
      event_label: promptName
    });
  }

  // Track settings changes
  trackSettingsChange(settingName, settingValue) {
    this.trackEvent('settings_change', {
      event_category: 'user_preferences',
      event_label: settingName,
      custom_parameter_1: typeof settingValue
    });
  }

  // Update measurement ID
  updateMeasurementId(newMeasurementId) {
    this.measurementId = newMeasurementId;
    localStorage.setItem('bullbearly-ga4-measurement-id', newMeasurementId);
    
    // Re-initialize with new ID
    this.initialize(newMeasurementId);
  }

  // Get current measurement ID
  getMeasurementId() {
    return this.measurementId;
  }

  // Check if analytics is enabled
  isAnalyticsEnabled() {
    return this.isInitialized && this.gtag !== null;
  }
}

// Create singleton instance
const analyticsService = new AnalyticsService();

export default analyticsService;
